<script>
    import { getDateRows, uuid, noop } from "./date-time.js";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    // props
    export let date;
    export let month;
    export let year;
    export let isAllowed;

    // local vars to help in render
    const weekdays = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    let cells;

    // function helpers
    const onChange = (date) => {
        dispatch("datechange", new Date(year, month, date));
    };

    const allow = (year, month, date) => {
        if (!date) return true;
        return isAllowed(new Date(year, month, date));
    };

    $: cells = getDateRows(month, year).map((c) => ({
        value: c,
        allowed: allow(year, month, c),
    }));
</script>

<div class="container">
    <div class="row">
        {#each weekdays as day}
            <div class="cell">{day}</div>
        {/each}
    </div>

    <div class="row">
        {#each cells as { allowed, value } (uuid())}
            <div
                on:click={allowed && value ? onChange.bind(this, value) : noop}
                class:cell={true}
                class:highlight={allowed && value}
                class:disabled={!allowed}
                class:selected={new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                ).getTime() === new Date(year, month, value).getTime()}
            >
                {value || ""}
            </div>
        {/each}
    </div>
</div>

<style>
    .container {
        margin-top: 8px;
        padding: 6px;
        width: 370px;
        z-index: 1000;
    }
    .row {
        display: flex;
        margin: 2px 6px;
        flex-wrap: wrap;
    }

    .row:first-child .cell {
        color: var(--ds-text-muted, #6b7280);
        font-size: 0.78rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .cell {
        display: inline-block;
        width: 40px;
        height: 30px;
        line-height: 22px;
        text-align: center;
        padding: 4px;
        margin: 1px;
        border-radius: var(--ds-radius-sm, 6px);
        color: var(--ds-text, #111827);
        box-sizing: border-box;
    }

    .selected {
        background: var(--ds-accent, #2563eb);
        color: #fff;
        font-weight: 600;
    }

    .highlight {
        transition: background 0.15s, color 0.15s;
    }

    .disabled {
        background: var(--ds-surface-2, #f7f9fb);
        cursor: not-allowed;
        color: var(--ds-text-subtle, #9ca3af);
    }

    .highlight:hover {
        background: var(--ds-surface-2, #f7f9fb);
        color: var(--ds-text, #111827);
        cursor: pointer;
    }

    .selected.highlight:hover {
        background: var(--ds-accent-hover, #1d4ed8);
        color: #fff;
    }
</style>
